import {
    ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS,
    ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminGetTransferTypeMappingList = () => {
    return { type: RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED };
};

const adminGetTransferTypeMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED });
    await adminServices
        .post("gettransferTypeMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
                payload: err
            });
        });
};

export { adminGetTransferTypeMappingList, resetadminGetTransferTypeMappingList };
